<div class="assessment-container">
  <div class="io-table-wrapper">
    <table class="io-table">
      <thead>
        <tr>
          <th>Section</th>
          <th>Description</th>
          <th>Intake</th>
          <th>Output</th>
          <th>Emesis</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Line</td>
          <td>{{ data().lineDescription }}</td>
          <td>{{ data().lineIntake }}</td>
          <td>{{ data().lineOutput }}</td>
          <td>—</td>
        </tr>
        <tr>
          <td>Tube</td>
          <td>{{ data().tubeDescription }}</td>
          <td>{{ data().tubeIntake }}</td>
          <td>{{ data().tubeOutput }}</td>
          <td>—</td>
        </tr>
        <tr>
          <td>Airway</td>
          <td>{{ data().airwayDescription }}</td>
          <td>—</td>
          <td>—</td>
          <td>—</td>
        </tr>
        <tr>
          <td>Drain</td>
          <td>{{ data().drainDescription }}</td>
          <td>{{ data().drainIntake }}</td>
          <td>{{ data().drainOutput }}</td>
          <td>—</td>
        </tr>
        <tr>
          <td>Oral</td>
          <td>{{ data().oralDescription }}</td>
          <td>{{ data().oralIntake }}</td>
          <td>—</td>
          <td>{{ data().oralEmesis }}</td>
        </tr>
        <tr>
          <td>Stool</td>
          <td>{{ data().stoolDescription }}</td>
          <td>—</td>
          <td>{{ data().stoolOutput }}</td>
          <td>—</td>
        </tr>
      </tbody>
    </table>
  </div>

  @if (patient().isPediatric()) {
  <hr class="section-divider" />
  <h2>Infant Nutrition</h2>

  <assessment-row title="Nutrition Assessment" [historyMode]="true">
    <p>{{ data().infantNutrition ? 'Yes' : 'No' }}</p>
  </assessment-row>

  @if (data().infantNutrition) {
  <assessment-row title="Breastfeeding" [historyMode]="true">
    <p>{{ data().breastfeeding ? 'Yes' : 'No' }}</p>
  </assessment-row>

  @if (data().breastfeeding) {
  <assessment-row title="Feeding Occurrence" [historyMode]="true">
    <p>{{ data().feedingOccurrence }}</p>
  </assessment-row>

  <div class="nested-section">
    <h3>Latch Scale</h3>
    <assessment-row title="Latch" [historyMode]="true">
      <p>{{ data().LSlatch }}</p>
    </assessment-row>
    <assessment-row title="Audible" [historyMode]="true">
      <p>{{ data().LSaudible }}</p>
    </assessment-row>
    <assessment-row title="Type" [historyMode]="true">
      <p>{{ data().LStype }}</p>
    </assessment-row>
    <assessment-row title="Comfort" [historyMode]="true">
      <p>{{ data().LScomfort }}</p>
    </assessment-row>
    <assessment-row title="Hold" [historyMode]="true">
      <p>{{ data().LShold }}</p>
    </assessment-row>
    <assessment-row title="Score" [historyMode]="true">
      <p>{{ data().LSscore }}</p>
    </assessment-row>
  </div>
  }

  <assessment-row title="Bottlefeeding" [historyMode]="true">
    <p>{{ data().bottlefeeding ? 'Yes' : 'No' }}</p>
  </assessment-row>

  @if (data().bottlefeeding) {
  <assessment-row title="Feeding Tolerance" [historyMode]="true">
    <p>{{ data().feedingTolerance }}</p>
  </assessment-row>
  <assessment-row title="Formula" [historyMode]="true">
    <p>{{ data().formula }}</p>
  </assessment-row>
  <assessment-row title="Number of Ounces" [historyMode]="true">
    <p>{{ data().numOfOunces }}</p>
  </assessment-row>
  }
  }
  }
</div>